import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { ServiceService } from './mastermodule/service/service.service';
import { Storage } from '@ionic/storage';
import { NavbarComponent } from './navbar/navbar.component';
import { MastermodulePageModule } from './mastermodule/mastermodule.module';
import { AdmissionPageModule } from './admission/admission.module';
import { ReqInterceptor } from './req-interceptor';
import { LoaderComponent } from './components/lottie-loader/lottie-loader.component';

// ✅ Correct import for LottieModule in v20+
// import {LottieComponent } from 'ngx-lottie'

// import player from 'lottie-web';

// export function playerFactory() {
//   return player;
// }

@NgModule({
  declarations: [AppComponent, NavbarComponent,LoaderComponent ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MastermodulePageModule,
    AdmissionPageModule,

    // ✅ Correct usage
    // LottieModule.forRoot({ player: playerFactory }),
  ],
  providers: [
    Storage,
    ServiceService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ReqInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
